<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 768 768">
<path fill="#FF3C8A" d="M0 320c0 176.731 143.269 320 320 320s320-143.269 320-320-143.269-320-320-320-320 143.269-320 320zM580 320c0 143.594-116.406 260-260 260s-260-116.406-260-260 116.406-260 260-260 260 116.406 260 260z"></path>
<path fill="#FF3C8A" d="M160 220l100 100-100 100 60 60 100-100 100 100 60-60-100-100 100-100-60-60-100 100-100-100z"></path>
</svg>
</template>
